import { ResourceKey } from "i18next";

export const CompanyPage: ResourceKey = {
	award: "award",
	bid: "offer",
	company_information_section_title: "Company information",
	competitors: "Competitors",
	buyers: "Buyers",
	suppliers: "Suppliers",
	copied_to_clipboard_title_1: 'Text "',
	copied_to_clipboard_title_: '" copied to clipboard',
	direct_competitor_title_1: "Direct competitor in",
	direct_competitor_title_2: "public tenders",
    shared_projects_title_1:"Tenders awarded",
    shared_projects_title_2:"from the company above",
	company_experience_title: "Experience",
	win_ratio_title_1: "Win ratio",
	win_ratio_title_2: "in public tenders",
	win_ratio_significant_increase: "significant increase",
	win_ratio_significant_decrease: "significant decrease",
	win_ratio_moderate_increase: "moderate increase",
	win_ratio_moderate_decrease: "moderate decrease",
	win_ratio_minor_change: "minor change",
	experience_graph_type_tenders_won: "Tenders Won",
	experience_graph_type_bids_won: "Bids Won",
	experience_title_2_tenders_won: "No tender win data for comparison",
	experience_tenders_won_minor_change: "minor change",
	experience_tenders_won_moderate_increase: "moderate increase",
	experience_tenders_won_moderate_decrease: "moderate decrease",
	experience_tenders_won_significant_increase: "significant increase",
	experience_tenders_won_significant_decrease: "significant decrease compared to last year",
	follow_company: "Follow this company: keep me informed when this company participates in a public tender and provide an overview in the awards tab",
	followed_company: "Followed company: ",
	main_activities_section_title: "Types of public tenders",
	main_buyers_section_title: "Main buyers",
	projects_contracted_title_1: "Contracts awarded",
	projects_contracted_title_2: "to the company above",
	recent_activity_section_title: "Recent public tenders",
	recently_participated_in_section_title: "Participated",
	contracted_open_section_title: "Open public tenders",
	contracted_closed_section_title: "Closed public tenders",
	recently_won_section_title: "Won",
	shared_projects_title: "Shared projects",
	show_company_page: "Show company page",
	tendering: "Tendering",
	tenders_contracted_closed_title: "Recently issued tenders",
	tenders_contracted_open_title: "Open tenders",
	unknown_company: "Unknown company",
	company_info_details_title: "Details",
	company_info_contact_title: "Contact",
	company_info_activities_title: "Activities",
	company_info_accreditations_title: "Accreditations",
	company_info_start_date_title: "Start date",
	price: "Price",
	quality: "Quality",
	balanced: "Hybrid",
	orientation: "Focus",
	priceOriented: "Price-oriented",
	qualityOriented: "Quality-oriented",
	averageLotValue: "Scope",
	verySmallScale: "Very small",
	smallScale: "Small",
	mediumScale: "Medium",
	largeScale: "Large",
	veryLargeScale: "Very large",
	government_category_title: "Search Contracting Authorities",
	company_category_title: "Search Companies",
	offers_and_awards_title: "Offers & Awards",
	frameworks_title: "Expiring Contracts",
	has_tender_experience: "Active in public tenders",
	lot_value_title_2: "based on winning bids this year",
	lot_value_significant_increase: "significant increase compared to last year",
	lot_value_significant_decrease: "significant decrease compared to last year",
	lot_value_moderate_increase: "moderate increase compared to last year",
	lot_value_moderate_decrease: "moderate decrease compared to last year",
	lot_value_minor_change: "compared to last year",
    bidStatus: {
        won: "Won",
        lost: "Lost",
        not_known: "Unknown",
    },

	graphLabel: {
		bids: 'Bids',
		wins: 'Wins',
		date: 'Date',
		value: 'Value',
		bid: 'Bid',
		tenders_won: "Tenders Won",
	},

    lotValueLabel: "Lot value",

    win_ratio_graph_type: "Winrate",
    lot_value_graph_type_scatter: "Lot Values",
    orientation_graph_type: "Orientation",

    experience_graph_type: "Experience",

    win_ratio_increase: "increase vs last year",
    win_ratio_decrease: "decrease vs last year",
    win_ratio_no_change: "no change vs last year",
    lot_value_increase: "increase vs last year",
    lot_value_decrease: "decrease vs last year",
    lot_value_no_change: "no change vs last year",
    experience_tenders_won_increase: "increase vs last year",
    experience_tenders_won_decrease: "decrease vs last year",
    experience_tenders_won_no_change: "no change vs last year",
    orientation_increase_price: "more price focused vs last year",
    orientation_decrease_price: "less price focused vs last year",
    orientation_no_change: "same price focus vs last year",
    tenders_plural: "tenders",

    orientationTooltip: {
        priceFocus: "Price Focus",
        priceCount: "Price Focused Wins",
        qualityCount: "Quality Focused Wins",
    },

    // Tooltips for WinRateGraph
    winrateGraph: {
        tooltipExpand: "Click to show details",
        tooltipCollapse: "Click to show summary",
    },
    statistics_tab_title: "Statistics",
};
